export type { GuideArticleBlockProps } from './GuideArticleBlock.types';
export { default } from './GuideArticleBlock';
